// extracted by mini-css-extract-plugin
export default {"contactItem":"ContactList_contactItem__ppNQ5","btnItemDel":"ContactList_btnItemDel__Ud7TP","contactInfo":"ContactList_contactInfo__Sgq6p"};